import type { DynaVault } from '../../../../api/DynaVaultsAPI';
import type { VaultOnChainData } from 'structure/pv2/dynavault/hooks/useVaultListBlockchain';
import type { Sort } from 'structure/pv2/dynavault/context/VaultListContext';
import { getVaultAPY } from 'structure/pv2/vault/utils/vault';

const getCreationTimestamp = (vault: DynaVault): number => {
  const timestamp = Date.parse(vault.createdAt);
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const sortVaultList = (
  vaultList: DynaVault[],
  onChainData: Record<`0x${string}`, VaultOnChainData>,
  sort: Sort
): DynaVault[] => {
  if (!sort || sort.direction === 'default') {
    return [...vaultList].sort(
      (a, b) => getCreationTimestamp(b) - getCreationTimestamp(a)
    );
  }

  return [...vaultList].sort((a, b) => {
    let aValue: number | string = 0;
    let bValue: number | string = 0;

    switch (sort.name) {
      case 'tvl':
        aValue = Number(onChainData[a.address]?.tvlUsd || 0);
        bValue = Number(onChainData[b.address]?.tvlUsd || 0);
        break;

      case 'position':
        aValue = onChainData[a.address]?.positionInUsd || 0;
        bValue = onChainData[b.address]?.positionInUsd || 0;
        break;
      case 'apy':
        aValue = getVaultAPY(a);
        bValue = getVaultAPY(b);
        break;
      case 'price':
        aValue = Number(onChainData[a.address]?.vaultPrice) || 0;
        bValue = Number(onChainData[b.address]?.vaultPrice) || 0;
        break;
      default:
        break;
    }

    if (sort.direction === 'desc') {
      return aValue > bValue ? -1 : 1;
    }

    return aValue > bValue ? 1 : -1;
  });
};
